import { useState } from 'react';
import { useFieldHelper, FieldProps, LinkField } from 'framework/ui/field';
import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  CUSTOMER_REPORT_STATUS,
  useProjectSecurityContext,
  useNewProjectUrl,
} from 'domain/shared/newProject';
import ExternalReportModalView from '../../createupdate/PreviewExternalReportModal';
import { useShowContext } from 'framework/show';
import { Button } from 'framework/ui/mui-builder';
import { Typography } from '@mui/material';

interface CustomReportLinkFieldProps extends FieldProps {
  id: string;
}

const CustomReportLinkField = ({ id, reportId, source, status, externalReportLink }: CustomReportLinkFieldProps) => {
  const { getValue } = useFieldHelper({ source });
  const { isAccessGranted } = useProjectSecurityContext();
  const { getValue: getReportID } = useFieldHelper({ source: reportId });
  const { getValue: getStatus } = useFieldHelper({ source: status });
  const { getValue: getExternalReportLink } = useFieldHelper({ source: externalReportLink });
  const { getApproveCustomerReportUrl, getUpdateCustomerReportUrl } = useNewProjectUrl();
  const [externalModalViewOpen, setExternalModalViewOpen] = useState(false);
  const { data } = useShowContext();

  const isApproveMode =
    !isAccessGranted(ACCESS_INFO_SECTIONS.CUSTOMER_REPORT, ACCESS_INFO_ACTIONS.MANAGE) ||
    getStatus() === CUSTOMER_REPORT_STATUS.IN_APPROVAL ||
    getStatus() === CUSTOMER_REPORT_STATUS.APPROVED ||
    getStatus() === CUSTOMER_REPORT_STATUS.CANCELED ||
    getStatus() === CUSTOMER_REPORT_STATUS.SENT;

  const getUrls = () => {
    return isApproveMode
      ? getApproveCustomerReportUrl(id!, getReportID())
      : getUpdateCustomerReportUrl(id!, getReportID());
  };

  return (
    <>
      {getExternalReportLink() ? (
        <Button link onClick={() => setExternalModalViewOpen(true)}>
          <Typography color="primary">{getValue()}</Typography>
        </Button>
      ) : (
        <LinkField isInternal={isApproveMode} value={getUrls()} linkText={getValue()} />
      )}

      <ExternalReportModalView
        data={data}
        externalModalViewOpen={externalModalViewOpen}
        setExternalModalViewOpen={setExternalModalViewOpen}
      />
    </>
  );
};
export default CustomReportLinkField;
